<template>
  <div v-if="biochar" class="biochar">
    <common-hero v-if="biochar.imageDesk" :background="{desktop: biochar.imageDesk.responsiveImage.src, mobile: biochar.imageMobile && biochar.imageMobile.responsiveImage ? biochar.imageMobile.responsiveImage.src : biochar.imageDesk.responsiveImage.src }" :tag="'div'" :scroll="true"
      :hasClass="'--vh100'">
      <span v-if="biochar.intro" v class="common-hero__processing-order common-hero-label text-to-uppercase">{{ biochar.intro }}</span>
      <div v-if="biochar.title" v-html="biochar.title"/>
      <div v-if="biochar.subtitle" v-html="biochar.subtitle" />
    </common-hero>

    <section class="padding-paragrafo padding-paragrafo--less-bottom azienda-style biochar-style">
      <div class="default-container">
        <div v-if="biochar.text1" v-html="biochar.text1" />
        <div  v-if="biochar.iconsUtilizzi && biochar.iconsUtilizzi.length > 0">
          <ul class="icons-grid">
            <li v-for="icon in biochar.iconsUtilizzi" :key="icon.text">
              <img v-if="icon.svg" :src="icon.svg.url" :alt="icon.text" class="icon-img"/>
              <span class="text-to-uppercase" v-html="icon.text ? icon.text.replace(/\n/g, '<br>') : ''"/>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="padding-paragrafo padding-paragrafo--less-top azienda-style biochar-style">
      <div class="default-container">
        <div v-if="biochar.text2" v-html="biochar.text2" />
        <div class="images-grid" v-if="biochar.imagesGrid.length > 0">
          <div v-for="(image, index) in biochar.imagesGrid" :key="index" class="img-container images-grid__item">
            <picture>
              <source :srcset="image.responsiveImage.src" media="(min-width: 1000px)">
              <img :src="image.responsiveImage.src" :alt="image.title">
            </picture>
            <span>{{ image.title }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="padding-paragrafo azienda-style biochar-style --dark-bg">
      <div class="default-container">
        <div v-if="biochar.text3" v-html="biochar.text3" />
        <div v-if="biochar.microscopeImage" class="img-container img-microscope">
          <picture>
            <source :srcset="biochar.microscopeImage.responsiveImage.src" media="(min-width: 1000px)">
            <img :src="biochar.microscopeImage.responsiveImage.src" :alt="biochar.microscopeImage.alt">
          </picture>
        </div>
        <div v-if="biochar.text4" v-html="biochar.text4" />
        <div class="graphs-block" v-if="biochar.graphsBlock.length > 0">
          <div v-for="(image, index) in biochar.graphsBlock" :key="index" class="img-container graphs-block__item">
            <picture>
              <source :srcset="image.responsiveImage.src" media="(min-width: 1000px)">
              <img :src="image.responsiveImage.src" :alt="image.title">
            </picture>
            <span>{{ image.title }}</span>
          </div>
        </div>
        <div v-if="biochar.text5" v-html="biochar.text5" />
        <div class="results-icons" v-if="biochar.resultsIcons.length > 0">
          <div v-for="(image, index) in biochar.resultsIcons" :key="index" class="img-container results-icons__item">
            <picture>
              <source :srcset="image.responsiveImage.src" media="(min-width: 1000px)">
              <img :src="image.responsiveImage.src" :alt="image.title">
            </picture>
          </div>
        </div>
      </div>
    </section>

    <section class="padding-paragrafo azienda-style biochar-style">
      <div class="default-container">
        <div v-if="biochar.text6" v-html="biochar.text6" />
      </div>
    </section>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import { biocharPage } from '@/queries/biochar.js'

export default {
  mixins: [ lang, dataLoad ],
  name: 'home',
  components: {
    CommonHero
  },
  data: () => ({
    biochar: {},
    seo: {}
  }),
  apollo: {
    biochar: {
      query: biocharPage,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.biochar = result.data.biochar
          this.seo = this.biochar.seo
        }
      }
    }
  },
  props: {
    hash: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
@import "../assets/mixins/typo";
@import "../assets/mixins/common";

  .icons-grid{
    display: grid;
    overflow: hidden;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 15px;
    width: 100%;
    align-items: baseline;
    margin-top: 80px;
    margin-bottom: 95px;

    @media #{$small_mq} {
      grid-column-gap: 15px;
      grid-row-gap: 15px;
    }
    @media #{$large_mq} {
      grid-template-columns: repeat(4, 1fr);
      margin-top: 100px;
      margin-bottom: 120px;
    }

    li {
      padding: 50px 15px;
      background-color: #FFF;
      text-align: center;
      height: 100%;

      @media #{$small_mq} {
        padding: 20px 15px;
      }

      img{
        // max-width: 200px;
        max-width: 150px;
        width: 100%;

        @media #{$small_mq} {
          // max-width: 150px;
          max-width: 90px;
          width: 100%;
        }
        @media #{$large_mq} {
          max-width: 128px;
        }

      }

      span{
        width: 100%;
        display: block;
        font-size: .9rem;
        font-family: 'IBM Plex Mono', sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        color: #343434;
        margin-top: 10px;

        @media #{$medium_mq} {
          font-size: .95rem;
        }
        @media #{$large_mq} {
          font-size: 1.05rem;
        }
        @media #{$xlarge_mq} {
          font-size: 1.15rem;
        }
        @media #{$xxlarge_mq} {
          font-size: 1.25rem;
        }
      }
    }
  }

  .images-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    padding-top: 80px;
  }

  .images-grid__item {
    width: 100%;

    & + & {
      margin-top: 35px;
    }

    span {
      display: block;
      margin-top: 10px;
      font-size: .8rem;
      line-height: 1.6;
      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 400;
      color: #343434;
    }

    @media #{$large_mq} {
      width: 49%;

      & + & {
        margin-top: 0;
      }

      span {
        margin-top: 15px;
        font-size: 1.1rem;
      }
    }
  }

  .img-container{
    picture {
      height: auto;
      width: 100%;
      display: block;

      img {
        display: block;
        width: 100%;
        height: auto;
        margin: 0;
      }
    }
    a{
      //display: inline-block;
      position: absolute;
      right: 0;
      bottom: 4px;
    }
  }

  .biochar-style{
    h1, h2{
      @include section-title(#343434);
      text-transform: uppercase;
      margin: 0 0 30px;
      @media #{$large_mq} {
        margin: 0 0 35px;
      }
      @media #{$xlarge_mq} {
        margin: 0 0 40px;
      }
    }
    h3 {
      font-size: 1.3rem;
      line-height: 1.3;
      font-family: 'IBM Plex Sans Condensed', sans-serif;
      font-weight: 300;
      color: #343434;
      width: 90%;
      @media #{$medium_mq} {
        font-size: 1.65rem;
      }
      @media #{$large_mq} {
        font-size: 2rem;
        width: 80%;
      }
      @media #{$xlarge_mq} {
        font-size: 2.5rem;
        width: 70%;
      }
      @media #{$xxlarge_mq} {
        font-size: 2.8125rem;
      }
      margin: 0 0 40px;
      @media #{$large_mq} {
        margin: 0 0 60px;
      }
      @media #{$xlarge_mq} {
        margin: 0 0 70px;
      }
    }
    p{
      margin: 0 0 40px;
      @media #{$large_mq} {
        margin: 0 0 60px;
      }
      @media #{$xlarge_mq} {
        margin: 0 0 70px;
      }

      font-size: 1rem;
      line-height: 1.6;
      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 400;
      color: #343434;
      width: 90%;
      @media #{$medium_mq} {
        font-size: 1.1rem;
      }
      @media #{$large_mq} {
        font-size: 1.2rem;
        width: 80%;
      }
      @media #{$xlarge_mq} {
        font-size: 1.35rem;
        width: 75%;
      }
      @media #{$xxlarge_mq} {
        font-size: 1.5rem;
      }
      strong{
        font-weight: 700;
      }
    }
    p + h2 {
      margin-top: 60px;
      @media #{$large_mq} {
        margin-top: 80px;
      }
      @media #{$xlarge_mq} {
        margin-top: 90px;
      }
    }
    ul:not(.icons-grid) {
      li + li {
        margin-top: 25px;
      }
      li {
        font-size: 1rem;
        line-height: 1.6;
        font-family: 'IBM Plex Mono', sans-serif;
        font-weight: 400;
        display: list-item;
        list-style-type: disc;
        list-style-position: inside;

        @media #{$medium_mq} {
          font-size: 1.1rem;
        }
        @media #{$large_mq} {
          font-size: 1.2rem;
          width: 80%;
        }
        @media #{$xlarge_mq} {
          font-size: 1.35rem;
          width: 70%;
        }
        @media #{$xxlarge_mq} {
          font-size: 1.5rem;
        }
      }
    }

    &.--dark-bg {
      background-color: #343434;
      color: #ffffff;

      h3 {
        color: #ffffff;
        font-size: 2.3rem;

        br {
          display: none;
        }

        @media #{$medium_mq} {
          font-size: 4.3rem;
          br {
            display: block;
          }
        }
      }
      p, ul, li {
        color: #ffffff;
      }
      strong {
        color: #39B886;
      }
      a {
        text-decoration: underline;
        color: #ffffff;
      }
      .img-microscope {
        padding-top: 30px;
        padding-bottom: 70px;
        max-width: 690px;

        @media #{$medium_mq} {
          padding-top: 70px;
          padding-bottom: 170px;
        }
      }
      .graphs-block {
        padding-top: 30px;
        padding-bottom: 70px;
        color: #ffffff;

        .graphs-block__item + .graphs-block__item {
          margin-top: 70px;
        }

        img {
          max-width: 830px;
        }

        span {
          display: block;
          margin-top: 20px;
          font-size: .8rem;
          line-height: 1.6;
          font-family: 'IBM Plex Mono', sans-serif;
          font-weight: 400;
          width: 90%;
        }

        @media #{$large_mq} {
          .graphs-block__item + .graphs-block__item {
            margin-top: 140px;
          }

          span {
            margin-top: 60px;
            font-size: 1.1rem;
            width: 75%;
          }
        }

        @media #{$medium_mq} {
          padding-top: 140px;
          padding-bottom: 170px;
        }
      }

      .results-icons {
        display: flex;
        gap: 50px;

        picture {
          display: inline-block;
        }

        @media #{$medium_mq} {
          gap: 90px;
        }
      }
    }
  }

</style>
